import { useEffect } from 'react'

/**
 * Keeps the screen on while the detail view is mounted — the difference between pleasant and
 * infuriating when cooking with messy hands. Silently does nothing on browsers without the
 * API (Firefox, older Safari): losing the wake lock there is a no-op, not a broken page.
 */
export function useWakeLock(active: boolean) {
  useEffect(() => {
    if (!active || !('wakeLock' in navigator)) return

    let sentinel: WakeLockSentinel | null = null
    let cancelled = false

    navigator.wakeLock
      .request('screen')
      .then((lock) => {
        if (cancelled) {
          void lock.release()
        } else {
          sentinel = lock
        }
      })
      .catch(() => {
        // Permission denied or tab not visible — nothing to recover from.
      })

    return () => {
      cancelled = true
      void sentinel?.release()
    }
  }, [active])
}
